var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.167 166.667H186.667C179.666 166.667 176.166 166.667 173.492 168.029C171.14 169.227 169.228 171.14 168.029 173.492C166.667 176.166 166.667 179.666 166.667 186.667V213.333C166.667 220.334 166.667 223.834 168.029 226.508C169.228 228.86 171.14 230.772 173.492 231.971C176.166 233.333 179.666 233.333 186.667 233.333H213.333C220.334 233.333 223.834 233.333 226.508 231.971C228.86 230.772 230.773 228.86 231.971 226.508C233.333 223.834 233.333 220.334 233.333 213.333V195.833",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 216.667L184.554 198.78C186.181 197.152 188.819 197.152 190.446 198.78L204.167 212.5M204.167 212.5L215.804 200.863C217.431 199.236 220.069 199.236 221.696 200.863L233.333 212.5M204.167 212.5L213.542 221.875",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.333 187.833V167M224.333 167L216 175.333M224.333 167L232.667 175.333",
    stroke: "#2A76F4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/uploadPhoto.c6acd03208f5c35030999456bfaa1bd5.svg";
export { ForwardRef as ReactComponent };